import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { CircularProgress, Box } from '@mui/material';

interface ReportsRouteProps {
  children: React.ReactNode;
}

// Reports user IDs who can access reports
const REPORTS_USER_IDS = ['01Hy3G8tILYY3wJ4z2481xrGh493', 'DXXr7tC2Q7d8h3HFpRrwsOCEtKs2', 'bBetdjepqIenXUsp8tnPu1SeH7F3'];

export const ReportsRoute: React.FC<ReportsRouteProps> = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with the current location as the return URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has access to reports
  const hasReportsAccess = REPORTS_USER_IDS.includes(user?.uid || '');

  if (!hasReportsAccess) {
    // Redirect to dashboard if not authorized
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
